import axios from '../../plugins/axios'

export const cancelPackage = (_, { id, data } = {}) => {
  return axios.put(`/package/${id}/cancel`, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
    .then(response => response.data)
}

export const uncancelPackage = (_, { id } = {}) => {
  return axios.put(`/package/${id}/uncancel`)
    .then(response => response.data)
}

export const editPackage = (_, { id, data } = {}) => {
  return axios.put(`/package/${id}`, data)
    .then(response => response.data)
    .catch(err => err.response)
}

export const updatePackageDebug = (_, { id, data } = {}) => {
  return axios.put(`/package/${id}/debug`, data)
    .then(response => response.data)
    .catch(err => err.response)
}

export const getPackageHistory = (_, { id } = {}) => {
  return axios.get(`/package/${id}/history`)
    .then(response => response.data)
    .catch(err => err.response)
}

export const massiveCancelPackage = (_, data) => {
  return axios.put('/packages/massive-cancel', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
    .then(response => response.data)
}

export const updateReceptionPackage = (_, { id, code, data } = {}) => {
  if (code) { id = code }
  return axios.put(`/package/${id}/reception`, data)
    .then(response => response.data)
    .catch(err => err.response)
}
export const updatePickupPackage = (_, { id, data } = {}) => {
  return axios.put(`/package/${id}/pickup`, data)
    .then(response => response.data)
    .catch(err => err.response)
}
export const updateInTransitPackage = (_, { id, data } = {}) => {
  return axios.put(`/package/${id}/in-transit`, data)
    .then(response => response.data)
    .catch(err => err.response)
}
export const updateExchangeOrReturnPackage = (_, { id, data } = {}) => {
  return axios.put(`/package/${id}/exchange-or-return`, data)
    .then(response => response.data)
    .catch(err => err.response)
}

export const registerLabelPrint = (_, { ids } = {}) => {
  return axios.put('/package/register-label-print', { ids })
    .then(response => response.data)
    .catch(err => err.response)
}

export const packageScanning = (_, data = {}) => {
  return axios.put('/package-scanning', data)
}

export const listPackage = async ({ commit }, { code } = {}) => {
  try {
    const response = await axios.get(`/package/${code}`)
    commit('SET_PACKAGE', response.data)
    return response
  } catch (err) {
    return err.response
  }
}

export const getPackageToScanRutaConductor = async () => {
  try {
    const response = await axios.get('/package/to-scan/ruta-conductor')
    return response
  } catch (err) {
    return err.response
  }
}

export const checkPackageExternalId = (_, { externalIds, storeId } = {}) => {
  return axios.post('/package/check-external-id', { externalIds, storeId })
}

export const getPackageByLabelCode = (_, { labelCode, labelProvider } = {}) => {
  return axios.post('/package/get-by-label-code', { labelCode, labelProvider })
}